<template>
  <div>
    <b-table
      v-if="orders"
      ref="table"
      :fields="fields"
      :items="orders"
      class="mt-u3"
      show-empty
      empty-text="No purchase order"
      tbody-tr-class="row__order"
      responsive
    >
      <template #cell(order_no)="data">
        <router-link
          class="font-weight-bold text__order-id"
          :to="{ name: 'purchase-detail', params: { orderId: data.item.id } }"
          >{{ data.value }}</router-link
        >
      </template>

      <template #cell(total_amount)="data">
        <span class="text__price">{{ $_formatPrice(data.value) }} THB</span>
      </template>

      <template #cell(created_at)="data">
        <span class="text__payment-date">{{
          formatedDatetime(data.item.latest_payment.updated_at, 'MMM D, YYYY hh:mm a')
        }}</span>
      </template>

      <template #cell(receipt_status)="data">
        <span class="text__receipt-status">
          <b-badge
            pill
            class="badge__receipt-status"
            :variant="displayVariant(data.item.receipt)"
            :class="displayTextVariant(data.item.receipt)"
          >
            {{ displayStatus(data.item.receipt) }}
          </b-badge>
        </span>
      </template>

      <template #cell(action)="data">
        <b-img
          ref="icon__download"
          :src="require('@/assets/icon-files-list/download.svg')"
          class="icon__download"
          :class="displayButton(data.item.receipt)"
          @click="onClickDownload(data.item.receipt)"
        >
        </b-img>
      </template>
    </b-table>
  </div>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
import { formatPriceMixin } from '@/mixins/formatPriceMixin';
import { formatPaymentMethodMixin } from '@/mixins/formatPaymentMethodMixin';
import Upload from '@/models/Upload';

export default {
  mixins: [datetimeMixin, formatPriceMixin, formatPaymentMethodMixin],
  props: {
    orders: { type: Array, default: () => [] },
    fields: {
      type: Array,
      default: () => [
        {
          key: 'order_no',
          label: 'ORDER NO',
          thClass: 'bg-white'
        },
        {
          key: 'total_amount',
          label: 'PRICE',
          thClass: 'bg-white'
        },
        {
          key: 'created_at',
          label: 'PAYMENT DATE',
          thClass: 'bg-white'
        },
        {
          key: 'receipt_status',
          label: 'RECEIPT STATUS',
          thClass: 'bg-white'
        },
        {
          key: 'action',
          label: '',
          thClass: 'bg-white'
        }
      ]
    }
  },

  methods: {
    isValidToDownload(receipt) {
      return receipt && receipt.status && receipt.id;
    },

    displayStatus(receipt) {
      return this.isValidToDownload(receipt) ? 'COMPLETED' : 'IN PROGRESS';
    },

    displayVariant(receipt) {
      return this.isValidToDownload(receipt) ? 'neutral-success' : 'neutral-warning';
    },

    displayTextVariant(receipt) {
      return this.isValidToDownload(receipt) ? 'text-success' : 'text-warning';
    },

    displayButton(receipt) {
      return this.isValidToDownload(receipt) ? 'icon-can_download' : 'icon-can-not_download';
    },

    onClickDownload(receipt) {
      if (this.isValidToDownload(receipt)) {
        this.downloadReceipt(receipt);
      }
    },

    async downloadReceipt(receipt) {
      try {
        const {
          response: {
            data: { url, name }
          }
        } = await Upload.api().downloadReceipt(receipt.id);

        // Create a temporary link element
        const a = document.createElement('a');
        a.href = url;
        a.download = name || 'downloaded-receipt';
        a.target = '_blank'; // Open in new tab as fallback
        a.rel = 'noopener noreferrer'; // Security best practice
        
        // Trigger the download
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        this.$emit('success:download-receipt');
      } catch (error) {
        console.error(error);

        this.$toast.open({
          message: 'Your purchase receipt failed to download, please try again.',
          type: 'error',
          duration: 5000
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.badge__receipt-status {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 12px;
  width: max-content;
}

.icon-can_download {
  cursor: pointer;
}

.icon-can-not_download {
  opacity: 0.4;
}
</style>
